<template>
  <div class="router-transitions container-fluid flex-grow-1 container-p-y">
    <h4 class="d-flex justify-content-between align-items-center w-100 font-weight-bold py-3 mb-4">
      Settings
    </h4>
    <b-card no-body>
      <b-tabs card>
        <b-tab title="Permissions" active>
          <Permissions />
        </b-tab>
        <b-tab title="SCIM" v-if="hasScim">
          <Scim />
        </b-tab>
        <b-tab title="SAML" v-if="hasSaml">
          <Saml />
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import Permissions from '@/components/settings/Permissions.vue'
import Scim from '@/components/settings/Scim.vue'
import { mapState } from 'vuex'
import Saml from '@/components/settings/Saml.vue'

export default {
  name: 'Settings',
  components: {
    Permissions,
    Scim,
    Saml,
  },
  computed: {
    ...mapState('auth', ['user']),
    hasScim() {
      return this.user.scim_sync_enabled
    },
    hasSaml() {
      return this.user.saml_auth_enabled
    }
  }
}
</script>

<style scoped></style>
